module.exports = __webpack_public_path__ + "static/pommes-5e5bb081e43182deefd4635e1ebe10ae.jpg";